import {Component, OnInit, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogService} from '@rbaip/ui-component';
import {ItemSummaryAssetsService} from '../../../shared/asset/item-summary-assets.service';
import {Opportunity} from '../../../shared/domain/opportunity';
import {MatStepper} from "@angular/material/stepper";

@Component({
  selector: 'lib-create-addendum-assets',
  templateUrl: './create-addendum.component.html',
  styleUrls: ['./create-addendum.component.scss'],
})

export class CreateAddendumComponent implements OnInit {

  public errorMessage: string;
  private contractUrl: string = "";
  private opportunity: Opportunity;
  private stepper: MatStepper;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              private dialogService: DialogService,
              private assetsService: ItemSummaryAssetsService) {
    this.errorMessage = this.data.errorMessage;
    this.opportunity = this.data.opportunity;
    this.stepper = this.data.currentStepper;
  }

  ngOnInit() {
    this.getSandBoxUrl();
  }

  public createAddendum(): void {
    window.open(this.contractUrl, '_blank');
  }

  public moveAsset(): void {
    this.stepper.next();
  }

  private getSandBoxUrl() {
    this.dialogService.showProgress();
    this.assetsService.getSandBoxUrl().subscribe(response => {
      this.contractUrl = response.sandBoxUrl + "/" + this.opportunity.contractId;
      this.dialogService.hideProgress();
    })
  }
}
